export default __webpack_public_path__ + "static/media/Payments Icon.7146884b.svg";